module.exports = __webpack_public_path__ + "img/area-limit-cancel-btn.b754fdb0.png";